<template>
  <Photos year="2021" :min-date="1616544000" :max-date="1616716800" date-text="March 24&ndash;26" />
</template>

<script setup>
import Photos from "@/components/Photos.vue";
</script>
